import classNames from 'classnames';
import React, { FC } from 'react'
import { SvgIcon } from '../../SvgIcon/SvgIcon';

type CloseButtonProps = {
  onClick: () => void;
  withWhiteBg?: boolean;
  className?: string;
}

export const CloseButton: FC<CloseButtonProps> = (props) => {
  const { onClick, withWhiteBg = "false", className } = props;

  return (
    <button
      className={classNames("CloseButton", className)}
      onClick={onClick}
    >
      <SvgIcon iconName="close" className="CloseButton__icon" hideFromScreenReaders />
      <span className="visually-hidden">
        Lukk
      </span>
    </button>
  )
};
